import React from "react";
import { LogoBlock } from "./styled";
import logoNew from "./../../../resources/images/main/logo_new.svg";
import logoText from "./../../../resources/images/main/logo_text.svg";
import { Text } from "../../../styled";
import { greyTextColor } from "../../../constants/colors";

const Logo = (props) => {
  const { align, type, link, text } = props;

  const checkLogoOnType = () => {
    switch (type) {
      case "preland":
        return preLandLogoRender();
    }
  };

  const handleLogoClick = () => {
    window.location.href = link;
  };

  const preLandLogoRender = () => {
    return (
      <LogoBlock.Preland onClick={() => handleLogoClick()}>
        <LogoBlock.Preland.Left>
          <img src={logoNew} alt="logo" />
        </LogoBlock.Preland.Left>
        <LogoBlock.Preland.Right>
          <img
            src={logoText}
            style={{ width: 76, marginBottom: 7 }}
            alt="Journey"
          />
          <Text.Eight
            style={{
              color: greyTextColor,
              textTransform: "none",
              letterSpacing: 0,
            }}
          >
            {text}
          </Text.Eight>
        </LogoBlock.Preland.Right>
      </LogoBlock.Preland>
    );
  };

  return <LogoBlock>{checkLogoOnType()}</LogoBlock>;
};

export default Logo;
